import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Member from "../views/Member.vue";
import Lottery from "../views/Lottery.vue";
import Game from "../views/Game.vue";
import LotterySet from "../views/LotterySet.vue";
import Register from "../views/user/Register.vue";
import RegisterWithAf from "../views/user/RegisterWithAf.vue";
import ForgotPassword from "../views/user/ForgotPassword.vue";
import Affiliate from "../views/member/Affiliate.vue";
import NumberSet from "../views/member/NumberSet.vue";
import Deposit from "../views/member/Deposit.vue";
import Withdraw from "../views/member/Withdraw.vue";
import Transaction from "../views/member/Transaction.vue";
import Casino from "../views/member/Casino.vue";
import Poy from "../views/member/Poy.vue";
import PoyDetail from "../views/member/PoyDetail.vue";
import Statement from "../views/member/Statement.vue";
import Jackpot from "../views/member/Jackpot.vue";
import Result from "../views/member/Result.vue";
import HowTo from "../views/member/HowTo.vue";
import Profile from "../views/member/settings/Profile.vue";
import Bank from "../views/member/settings/Bank.vue";
import AddBankAcc from "../views/member/settings/bank/Add.vue";
import BankAccStatus from "../views/member/settings/bank/Status.vue";
import Government from "../views/lottery/government.vue";
import Tang from "../views/lottery/tang.vue";
import Yeekee from "../views/lottery/yeekee.vue";
import TangYeekee from "../views/lottery/tangyeekee.vue";
import LotterySetLaos from "../views/lotteryset/LotterySetLaos.vue";
import LotterySetHanoi from "../views/lotteryset/LotterySetHanoi.vue";
import LotterySetMalay from "../views/lotteryset/LotterySetMalay.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/member",
    name: "Member",
    component: Member
  },
  {
    path: '/member/settings/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/member/settings/bank',
    name: 'Bank',
    component: Bank
  },
  {
    path: '/member/settings/bank/add',
    name: 'AddBankAcc',
    component: AddBankAcc
  },
  {
    path: '/member/settings/bank/status',
    name: 'BankAccStatus',
    component: BankAccStatus
  },
  {
    path: '/member/poy',
    name: "Poy",
    component: Poy
  },
  {
    path: '/member/poy/:type/:lottoType/:id',
    name: "PoyDetail",
    component: PoyDetail,
    props: true
  },
  {
    path: '/member/deposit',
    name: "Deposit",
    component: Deposit
  },
  {
    path: '/member/withdraw',
    name: "Withdraw",
    component: Withdraw
  },
  {
    path: '/member/transaction',
    name: "Transaction",
    component: Transaction
  },
  {
    path: '/member/casino',
    name: "Casino",
    component: Casino
  },
  {
    path: '/member/statement',
    name: "Statement",
    component: Statement
  },
  {
    path: '/member/affiliate/:page',
    name: "Affiliate",
    component: Affiliate,
    props: true
  },
  {
    path: "/member/numbersets/:page/:id",
    name: "NumberSet",
    component: NumberSet,
    props: true
  },
  {
    path: "/member/numbersets/:page?",
    name: "NumberSet",
    component: NumberSet,
    props: true
  },
  {
    path: "/member/jackpot/:page?",
    name: "Jackpot",
    component: Jackpot,
    props: true
  },
  {
    path: "/member/result/:page?",
    name: "Result",
    component: Result,
    props: true
  },
  {
    path: "/howto",
    name: "HowTo",
    component: HowTo
  },
  {
    path: "/lottery/yeekee/:lottoName/:id",
    name: "LotteryPingPongVIP",
    component: Tang,
    props: true
  },
  {
    path: "/lottery/government/:lottoName/:id",
    name: "LotteryGovernment",
    component: Tang,
    props: true
  },
  {
    path: "/lottery/stock/:lottoName/:id",
    name: "LotteryStock",
    component: Tang,
    props: true
  },
  {
    path: "/lottery",
    name: "Lottery",
    component: Lottery
  },
  {
    path: "/game",
    name: "Game",
    component: Game
  },
  // {
  //   path: "/lotteryset/hanoi",
  //   name: "LotterySetHanoi",
  //   components: LotterySetHanoi
  // },
  // {
  //   path: "/lotteryset/malay",
  //   name: "LotterySetMalay",
  //   components: LotterySetMalay
  // },
  {
    path: "/lotteryset",
    name: "LotterySet",
    component: LotterySet
  },
  {
    path: "/member/lottery/set/laos/:page?",
    name: "LotterySetLaos",
    component: LotterySetLaos,
    props: true
  },
  {
    path: "/member/lottery/set/hanoi/:page?",
    name: "LotterySetHanoi",
    component: LotterySetHanoi,
    props: true
  },
  {
    path: "/member/lottery/set/malay/:page?",
    name: "LotterySetMalay",
    component: LotterySetMalay,
    props: true
  },
  {
    path: "/register/:step?",
    name: "Register",
    component: Register,
    props: true
  },
  {
    path: "/register/af/:id",
    name: "RegisterWithAf",
    component: Register,
    props: true
  },  
  {
    path: "/forgot-password/:step?",
    name: "ForgotPassword",
    component: ForgotPassword,
    props: true
  },
  // Max
  {
    path: "/lottery/government",
    name: "Government",
    component: Government,
    props: true
  },
  {
    path: "/lottery/PingPongVIP",
    name: "Yeekee",
    component: Yeekee,
    props: true
  },
  // {
  //   path: "/lottery/:lottoName/:id",
  //   name: "TangYeekee",
  //   component: Tang,
  //   props: true
  // }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
